import { createFileRoute } from '@tanstack/react-router';
import { OrderListRoute, validateOrderListSearch } from './-order-list-route';

export const Route = createFileRoute('/_order-list/reports/view/$reportGuid')({
  validateSearch: validateOrderListSearch,
  component: ReportRoute,
});

function ReportRoute() {
  const { reportGuid } = Route.useParams();
  return <OrderListRoute reportGuid={reportGuid} />;
}
